import React from 'react'
import SuperUserTxnPageUI from '../../../templates/SuperUserTxnPageUI.js'
import FixedDepositListUI from '../../../components/superUser/nodalTxn/FixedDepositListUI'
import SpinnerComponentUI from '../../../components/common/SpinnerComponentUI'

const FixedDepositListPageUI = ({
  context, accountNumber, onRefreshClick,
  fdTransferList, totals, fdTransactions, fdMonthlyTotals, fdTxnList,
  financialYear, financialYearList, onFinancialYearChange
}) =>
  <SuperUserTxnPageUI context={context} className='pg_su_fd' topnav='transactions' backLink='/su/accounts'
    headerText='Accounts' centered={!totals}
    page={accountNumber === '007105010733' ? '0733fd' : '4441fd'}
  >
    {
      (!totals) &&
      <SpinnerComponentUI />
    }
    {
      totals &&
      <FixedDepositListUI
        context={context}
        accountNumber={accountNumber}
        fdTransferList={fdTransferList}
        fdTransactions={fdTransactions}
        fdTxnList={fdTxnList}
        totals={totals}
        fdMonthlyTotals={fdMonthlyTotals}
        onRefreshClick={onRefreshClick}
        //
        financialYear={financialYear}
        financialYearList={financialYearList}
        onFinancialYearChange={onFinancialYearChange}
      />
    }

  </SuperUserTxnPageUI>

export default FixedDepositListPageUI
